import { ISubscriptionInfo } from '../../ts/models/ISubscriptionInfo';
import { Subscriptions } from '../../dda/resources/Subscriptions';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ToasterService, ToastType } from '../../ts/services/ToasterService';
import { Messages } from '../../codegen/Localize';

export const SUCCESS_TOAST_TEST_ID = 'resume-subscription-success';

export async function resumeSubscription(subscription: ISubscriptionInfo): Promise<IResult> {

  const result = await Subscriptions.resume(subscription.id);

  return notify(result, subscription.subject);
}

export function notify(result: IResult, subject: string): Promise<IResult> {
  if (!result.errors) {
    ToasterService.instance.pop({
      type: ToastType.Info,
      text: Messages.subscriptionResumeSuccess({ SUBJECT: subject }),
      testId: SUCCESS_TOAST_TEST_ID
    });
  } else {
    ToasterService.instance.pop({
      type: ToastType.Error,
      text: Messages.resumeSubscriptionFailure()
    });
  }

  return Promise.resolve(result);
}

export const ResumeSubscriptionAction = {
  resumeSubscription
};
